export default __webpack_public_path__ + "static/media/kashivishwanath.3c4661ea.jpeg";